import React, { useState } from 'react';
import TinyPopover, { PopoverProps } from 'react-tiny-popover';
import { InfoIcon } from './Icons';
import { Container } from './tooltip.styles';

type CustomTooltipProps = {
  button?: React.ReactElement;
  containerClassName?: string;
  position?: PopoverProps['position'];
};

const Popover: React.FC<CustomTooltipProps> = ({
  button = <InfoIcon />,
  children,
  containerClassName,
  position = ['right', 'top', 'bottom', 'left'],
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  return (
    <Container
      className={containerClassName}
      onClick={() => setIsPopoverOpen(!isPopoverOpen)}
    >
      <TinyPopover
        containerClassName="tooltip"
        content={children as React.ReactElement}
        isOpen={isPopoverOpen}
        onClickOutside={() => setIsPopoverOpen(false)}
        position={position}
      >
        {ref => React.cloneElement(button, { ref })}
      </TinyPopover>
    </Container>
  );
};

export default Popover;
